﻿import { JSX, ReactNode } from 'react';

type ConditionalWrapperProps<TChildren extends ReactNode = ReactNode> = {
    children: TChildren;
    condition: boolean;
    wrapper: (children: TChildren) => JSX.Element;
};

export const ConditionalWrapper = <TChildren extends ReactNode = ReactNode>(props: ConditionalWrapperProps<TChildren>): JSX.Element => {

    const { children, condition, wrapper } = props;
    return condition ? wrapper(children) : (
        <>
            {children}
        </>
    );

};